import TreeDataSupplier from 'business/tree/TreeDataSupplier';
import Explorer, { TreeControlDefaultState, TreeControlState } from 'components/explorer';
import React, { useEffect, useState } from 'react';
import { removeItemIfFoundElsePush } from 'utils/Global';
import { useOnNodeSelectionChange } from '../hooks';
import { filterAndTransformNode } from 'components/main/tree/utils';
import {
  useSelectedImageManagementTask,
  useSelectedImageTaskId,
} from 'redux/hooks/imageManagementTask';

const SearchPaths = () => {
  const [treeControlState, setTreeControlState] = useState<TreeControlState>(
    TreeControlDefaultState,
  );
  const onNodeSelectionChange = useOnNodeSelectionChange();
  const selectedTask = useSelectedImageManagementTask();
  const selectedTaskId = useSelectedImageTaskId();

  useEffect(() => {
    setTreeControlState((prev) => ({
      ...prev,
      checkedExplorerNodes: selectedTask?.explorerNodeIds ?? [],
    }));
  }, [selectedTaskId]);

  return (
    <div id="searchpaths-explorer" className="flex w-[97%] h-[100%] ml-[2%]">
      <Explorer
        backgroundColor="#ffffff"
        showQuickAccessNode={false}
        dataSupplier={TreeDataSupplier}
        treeControlState={treeControlState}
        setTreeControlState={setTreeControlState}
        shouldRenderNode={filterAndTransformNode}
        onCheckboxChange={(nodeid) => {
          const tempState = [...treeControlState.checkedExplorerNodes];

          removeItemIfFoundElsePush(tempState, nodeid);
          onNodeSelectionChange(tempState);
          setTreeControlState({
            ...treeControlState,
            checkedExplorerNodes: [...tempState],
          });
        }}
      />
    </div>
  );
};

export default SearchPaths;
